// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"5bcc43e3","358":"cf42b577"}[chunkId] + ".chunk.js";
};